import { Link } from "react-router-dom";
import { municipalities, candidates, ELECTION_DATE } from "../data/site";

export const Footer = () => (
    <footer data-testid="site-footer" className="mt-auto bg-navy text-ivory">
        <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6">
            <div className="grid gap-10 md:grid-cols-4">
                <div>
                    <p className="font-serif-display text-2xl font-bold">
                        HALTONS<span className="text-gold">.</span>CA
                    </p>
                    <p className="mt-3 text-sm text-ivory/70">
                        Your Region. Your Candidates. Independent civic coverage of the 2026
                        mayoral elections in Halton Region.
                    </p>
                    <p className="mt-4 text-sm font-semibold text-gold">
                        Election day: {ELECTION_DATE}
                    </p>
                </div>
                <div>
                    <p className="text-xs font-semibold uppercase tracking-widest text-gold">Municipalities</p>
                    <ul className="mt-3 space-y-2">
                        {municipalities.map((m) => (
                            <li key={m.slug}>
                                <Link to={`/${m.slug}`} data-testid={`footer-${m.slug}`} className="text-sm text-ivory/80 transition-colors hover:text-gold">
                                    {m.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="text-xs font-semibold uppercase tracking-widest text-gold">Candidate Profiles</p>
                    <ul className="mt-3 space-y-2">
                        {candidates.map((c) => (
                            <li key={c.slug}>
                                <Link to={`/candidates/${c.slug}`} data-testid={`footer-candidate-${c.slug}`} className="text-sm text-ivory/80 transition-colors hover:text-gold">
                                    {c.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
                <div>
                    <p className="text-xs font-semibold uppercase tracking-widest text-gold">Publication</p>
                    <ul className="mt-3 space-y-2">
                        <li><Link to="/issues" data-testid="footer-issues" className="text-sm text-ivory/80 transition-colors hover:text-gold">Issues &amp; Stories</Link></li>
                        <li><Link to="/about" data-testid="footer-about" className="text-sm text-ivory/80 transition-colors hover:text-gold">About &amp; Editorial Standards</Link></li>
                        <li><Link to="/corrections" data-testid="footer-corrections" className="text-sm text-ivory/80 transition-colors hover:text-gold">Report a Correction</Link></li>
                        <li><Link to="/contact" data-testid="footer-contact" className="text-sm text-ivory/80 transition-colors hover:text-gold">Contact Us</Link></li>
                    </ul>
                </div>
            </div>
            <div className="mt-12 border-t border-ivory/15 pt-6">
                <p className="text-xs text-ivory/60">
                    HALTONS.CA is an independent information website. It is not affiliated with any
                    municipal government or candidate campaign, and it is not an official municipal
                    election service.
                </p>
                <p className="mt-2 text-xs text-ivory/60">© 2026 HALTONS.CA — The People Shaping Halton.</p>
            </div>
        </div>
    </footer>
);
